    function openTaskDetail(task_uuid, activeTab) {
        var url = $('.kanban-container').data('detail_url');
        $.when($.ajax({
            url: url + '?uuid=' + task_uuid,
            async: false,
            cache: false,
            method: 'get',
            success: function (data) {
                if (data.status === 'success') {
                    //console.log(data);
                    $('#offcanvasKanban').html(data.data.content);
                    phoenix.phoenixOffcanvasInit();
                    phoenix.sortableInit();
                    tooltipInit();
                    tabChangeInit();
                    tagRemoveInit();
                    taskEditInit();
                    taskCompletedInit();
                    taskSupportInit();
                    if (typeof activeTab === 'string') {
                        //console.log('set active tab: ' + activeTab);
                        let tabTrigger = new bootstrap.Tab($('#taskDetailTab a#' + activeTab))
                        tabTrigger.show();
                    }
                } else {
                    bootbox.alert(data.msg);
                }
            },
            error: function (data) {
                bootbox.alert('Došlo k chybě při získávání detailu úkolu.');
            }, dataType: 'json'
        })).done(function (result) {
            return result;
        });
    }

    function taskSupportInit() {
        $('i.taskSupport').click(function () {
            $(this).tooltip('hide');
            var ajax_url = $(this).data('ajax_url');
            if (typeof ajax_url !== 'undefined') {
                //console.log(ajax_url);
                $.ajax({
                    type: 'POST',
                    url: ajax_url,
                    async: false,
                    dataType: 'json',
                    success: function (data) {
                        if (data.status == 'success') {
                            //console.log(data);
                            if (data.data.uuid) {
                                triggerOffcanvasUpdate(data.data.uuid);
                                updateTaskOnBoard(data.data.uuid, data.data);
                            }
                        } else {
                            bootbox.alert(data.msg);
                        }
                    },
                    error: function (data) {
                        // if error occured
                        bootbox.alert('Chyba při provádění operace');
                    }
                });
            }
        });
        $('i.taskSupport').removeClass('taskSupport');
    }

    function taskCompletedInit() {
        $('input.taskCompletedCheck').change(function () {
            var ajax_url = $(this).data('ajax_url');
            if (typeof ajax_url !== "undefined") {
                //console.log(ajax_url);
                $.ajax({
                    type: 'POST', url: ajax_url, async: false, dataType: 'json',
                    data: { 'Task[completed]': $(this).is(":checked") ? 1 : 0 },
                    success: function (data) {
                        if (data.status == 'success') {
                            //console.log(data);
                            if (data.data.uuid) {
                                triggerOffcanvasUpdate(data.data.uuid);
                                updateTaskOnBoard(data.data.uuid, data.data);
                            }
                        } else {
                            bootbox.alert(data.msg);
                        }
                    },
                    error: function (data) { // if error occured
                        bootbox.alert('Chyba při provádění operace');
                    }
                });
            }
        });
        $('input.taskCompletedCheck').removeClass('taskCompletedCheck');
        subtaskCompletedInit();
        checklistCompletedInit();
    }

    function subtaskCompletedInit() {
        $('input.subtaskCompletedCheck').change(function () {
            var ajax_url = $(this).data('ajax_url');
            if (typeof ajax_url !== "undefined") {
                //console.log(ajax_url);
                $.ajax({
                    type: 'POST', url: ajax_url, async: false, dataType: 'json',
                    data: { 'Task[completed]': $(this).is(":checked") ? 1 : 0 },
                    success: function (data) {
                        if (data.status == 'success') {
                            //console.log(data);
                            if (data.data.parent_uuid) {
                                triggerOffcanvasUpdate(data.data.parent_uuid);
                                updateTaskOnBoard(data.data.uuid, data.data);
                            }
                        } else {
                            bootbox.alert(data.msg);
                        }
                    },
                    error: function (data) { // if error occured
                        bootbox.alert('Chyba při provádění operace');
                    }
                });
            }
        });
        $('input.subtaskCompletedCheck').removeClass('subtaskCompletedCheck');
    }

    function checklistCompletedInit() {
        $('input.checklistCompletedCheck').change(function () {
            var ajax_url = $(this).data('ajax_url');
            if (typeof ajax_url !== "undefined") {
                //console.log(ajax_url);
                $.ajax({
                    type: 'POST', url: ajax_url, async: false, dataType: 'json',
                    data: { 'TaskChecklist[completed]': $(this).is(":checked") ? 1 : 0 },
                    success: function (data) {
                        if (data.status == 'success') {
                            //console.log(data);
                            if (data.data.parent_uuid) {
                                triggerOffcanvasUpdate(data.data.parent_uuid);
                            }
                        } else {
                            bootbox.alert(data.msg);
                        }
                    },
                    error: function (data) { // if error occured
                        bootbox.alert('Chyba při provádění operace');
                    }
                });
            }
        });
        $('input.checklistCompletedCheck').removeClass('checklistCompletedCheck');
    }

    function triggerOffcanvasUpdate(uuid = null) {

        let activeTab = $('#taskDetailTab a[data-bs-toggle="tab"].active').attr('id');
        //console.log('offcanvas active tab: ' + activeTab);
        if (document.getElementById('offcanvasKanban') !== null) {
            if (uuid === null) {
                uuid = $('#offcanvasKanban a[aria-label="Zobrazit detail"]').attr('href').split('?uuid=')[1];
            }
            //console.log('open task detail for #task-detail-' + uuid);
            openTaskDetail(uuid, activeTab);
        } else {
            if (uuid === null) {
                uuid = $('.task-detail').data('detail_url').split('?uuid=')[1].split('&')[0];
            }
            if (document.getElementById('task-detail-' + uuid) !== null) {
                //console.log('detail update for #task-detail-' + uuid);
                detailUpdate(uuid, activeTab);
            }
        }
    }

    function refreshFilesTab(data) {
        if (data.status === 'success') {
            triggerOffcanvasUpdate();
        }
    }

    function detailUpdate(uuid, activeTab) {
        let elDetail = $('#task-detail-' + uuid);
        var url = elDetail.data('detail_url');
        $.when($.ajax({
            url: url,
            async: false,
            cache: false,
            method: 'get',
            success: function (data) {
                if (data.status === 'success') {
                    //console.log(data);
                    elDetail.html(data.data.content);
                    tabChangeInit();
                    tagRemoveInit();
                    taskEditInit();
                    taskCompletedInit();
                    taskSupportInit();
                    if (typeof activeTab === 'string') {
                        //console.log('set active tab: ' + activeTab);
                        let tabTrigger = new bootstrap.Tab($('#taskDetailTab a#' + activeTab))
                        tabTrigger.show();
                    }
                } else {
                    bootbox.alert(data.msg);
                }
            },
            error: function (data) {
                bootbox.alert('Došlo k chybě při získávání detailu úkolu.');
            }, dataType: 'json'
        })).done(function (result) {
            return result;
        });
    }

    function updateTaskOnBoard(uuid, data) {
        //console.log('Update task on board: ' + uuid);
        //console.log(data);
        if (typeof data.title !== 'undefined') {
            $('#task-title-' + uuid).html(data.title);
        }
        if (typeof data.completed !== 'undefined') {
            if (data.completed === '1') {
                $('#task-title-' + uuid).addClass('text-decoration-line-through');
            } else {
                $('#task-title-' + uuid).removeClass('text-decoration-line-through');
            }
        }
        if (typeof data.support !== 'undefined') {
            if (data.support === '1') {
                $('#task-support-' + uuid)
                    .removeClass('text-danger')
                    .addClass('text-success');
            } else {
                $('#task-support-' + uuid)
                    .removeClass('text-success')
                    .addClass('text-danger');
            }
        }
        if (typeof data.priority !== 'undefined') {
            $('#task-priority-' + uuid).html(data.priority);
        }
        if (typeof data.tags !== 'undefined') {
            $('#task-tags-' + uuid).html(data.tags);
        }
        if (typeof data.solver !== 'undefined') {
            let solver = $('#task-solver-' + uuid);
            let solver_img = $('#task-solver-img-' + uuid);
            let div = $('#task-solver-div-' + uuid);
            if (typeof data.solver_photo !== 'undefined' && data.solver_photo !== null) {
                if (solver.length > 0) {
                    div.html(
                        '<div class="avatar avatar-s border border-light-subtle rounded-pill">' +
                        '   <img class="rounded-circle " id="task-solver-img-' + data.uuid + '" src="' + data.solver_photo + '" alt="' + data.solver_fullname + '" data-bs-toggle="tooltip" title="' + data.solver_fullname + '" />' +
                        '</div>'
                    );
                } else {
                    if (solver_img.length > 0) {
                        solver_img.attr('src', data.solver_photo);
                        solver_img.attr('alt', data.solver_fullname);
                        solver_img.attr('title', data.solver_fullname);
                        solver_img.attr('aria-label', data.solver_fullname);
                        solver_img.attr('data-bs-original-title', data.solver_fullname);
                    } else {
                        div.html(
                            '<div class="avatar avatar-s border border-light-subtle rounded-pill">' +
                            '   <img class="rounded-circle " id="task-solver-img-' + data.uuid + '" src="' + data.solver_photo + '" alt="' + data.solver_fullname + '" data-bs-toggle="tooltip" title="' + data.solver_fullname + '" />' +
                            '</div>'
                        );
                    }
                }
                if (div.hasClass('d-none')) {
                    div.removeClass('d-none');
                }
            } else {
                if (solver.length > 0) {
                    if (data.solver === '-') {
                        solver.html('');
                        if (!div.hasClass('d-none')) {
                            div.addClass('d-none');
                        }
                    } else {
                        solver.html(data.solver);
                        if (div.hasClass('d-none')) {
                            div.removeClass('d-none');
                        }
                    }
                } else {
                    if (data.solver !== '-') {
                        div.html(
                            '<div class="avatar avatar-s border border-light-subtle rounded-pill">' +
                            '   <div class="avatar-name rounded-circle text-body-quaternary bg-secondary-subtle"><span id="task-solver-' + data.uuid + '">' + data.solver + '</span></div>' +
                            '</div>'
                        );
                    } else {
                        div.html('');
                        if (!div.hasClass('d-none')) {
                            div.addClass('d-none');
                        }
                    }
                }
            }
        }
        if (typeof data.deadline !== 'undefined') {
            let deadline = $('#task-deadline-' + uuid);
            let p = $('#task-deadline-p-' + uuid);
            if (data.deadline === '-') {
                deadline.html('');
                if (!p.hasClass('d-none')) {
                    p.addClass('d-none');
                }
                if (p.hasClass('text-body')) {
                    p.removeClass('text-body');
                }
                if (p.hasClass('text-danger')) {
                    p.removeClass('text-danger');
                }
            } else {
                deadline.html(data.deadline);
                if (p.hasClass('d-none')) {
                    p.removeClass('d-none');
                }
                if (data.deadline_after) {
                    if (p.hasClass('text-body')) {
                        p.removeClass('text-body');
                    }
                    if (!p.hasClass('text-danger')) {
                        p.addClass('text-danger');
                    }
                } else {
                    if (p.hasClass('text-danger')) {
                        p.removeClass('text-danger');
                    }
                    if (!p.hasClass('text-body')) {
                        p.addClass('text-body');
                    }
                }
            }
        }
    }

    function tabChangeInit() {
        $('#taskDetailTab a[data-bs-toggle="tab"]').on('shown.bs.tab', function () {
            var ajax_url = $(this).data('ajax_url');
            if (typeof ajax_url !== "undefined") {
                var dest_id = $(this).attr('aria-controls');
                //console.log(ajax_url);
                //console.log(dest_id);
                if (dest_id === 'tab-comments') {
                    if (typeof window.tinymce !== 'undefined' && window.tinymce.activeEditor !== null && window.tinymce.activeEditor.id === 'task-description') {
                        if (typeof $('#taskdiscussion-content').val() !== 'undefined' && $('#taskdiscussion-content').val().length > 0) {
                            return true;
                        }
                    }
                }
                $.ajax({
                    type: 'POST', url: ajax_url, async: false, dataType: 'json',
                    success: function (data) {
                        if (data.status == 'success') {
                            //console.log(data);
                            $('#' + dest_id).html(data.data.content);
                            tooltipInit();
                            trackingRemoveInit();
                            taskEditInit();
                            if ($('textarea.tinymce').length > 0) {
                                tinymceInit(200);
                            }
                            if ($('#taskDetailTab a.active').attr('id') === 'files-tab') {
                                phoenix.dropzoneInit();
                                if (window.GLightbox) {
                                    window.GLightbox({
                                        selector: '[data-gallery]'
                                    });
                                }
                                $('a.file_remove').click(function (e) {
                                    e.preventDefault();
                                    $.ajax({
                                        type: "POST",
                                        url: $(this).attr('href'),
                                        success: function (data) {
                                            if (data.data.uuid) {
                                                $('#task-file-' + data.data.uuid).remove();
                                            }
                                        }
                                    });
                                });
                            }
                            if ($('#taskDetailTab a.active').attr('id') === 'comments-tab') {
                                var userChoice = $('#comment-notify-users');
                                if (userChoice.length > 0) {
                                    let choices = new Choices(userChoice[0], {
                                        removeItemButton: true,
                                        placeholder: true,
                                        loadingText: 'Načítání...',
                                        noResultsText: 'Nebyly nalezeny žádné výsledky',
                                        noChoicesText: 'Žádné možnosti na výběr',
                                        itemSelectText: 'Klikněte pro výběr',
                                        uniqueItemText: 'Lze přidat pouze jedinečné hodnoty',
                                    });
                                }
                                taskTrackingInit();
                                commentRemoveInit();
                                $('#task-comment-api-form').on('submit', function (e) {
                                    e.preventDefault();
                                    if (typeof tinymce !== 'undefined') {
                                        tinymce.triggerSave();
                                        if (tinymce.activeEditor !== null) {
                                            tinymce.activeEditor.save();
                                        }
                                    }
                                    var form = $(this);
                                    var actionUrl = form.attr('action');
                                    $.ajax({
                                        type: "POST",
                                        url: actionUrl,
                                        data: form.serialize(), // serializes the form's elements.
                                        success: function (data) {
                                            if (data.data.uuid) {
                                                triggerOffcanvasUpdate(data.data.uuid);
                                            } else {
                                                $('#taskDetailTab a#comments-tab').trigger('shown.bs.tab');
                                            }
                                        }
                                    });
                                });
                            }
                        } else {
                            bootbox.alert(data.msg);
                        }
                    },
                    error: function (data) { // if error occured
                        bootbox.alert('Chyba při provádění operace');
                    }
                });
            }
        });
    }

    function trackingRemoveInit() {
        $('a.tracking_remove').click(function (e) {
            e.preventDefault();
            if (!confirm('Opravdu smazat záznam?')) {
                return false;
            }
            var url = $(this).attr('href');
            if (typeof url !== "undefined") {
                //console.log(url);
                $.ajax({
                    type: 'POST', url: url, async: false, dataType: 'json',
                    success: function (data) {
                        if (data.status == 'success') {
                            //console.log(data);
                            $('#worklog-tab').trigger('shown.bs.tab');
                            $('#allTracked').html(data.data.tracked);
                            setProgressbarNewWidth($('#allTrackedProgress'), data.data.progress);
                        } else {
                            bootbox.alert(data.msg);
                        }
                    },
                    error: function (data) { // if error occured
                        bootbox.alert('Chyba při provádění operace');
                    }
                });
            }
        });
        $('a.tracking_remove').removeClass('tracking_remove');
    }

    function commentRemoveInit() {
        $('a.comment_remove').click(function (e) {
            e.preventDefault();
            var url = $(this).attr('href');
            if (typeof url !== "undefined") {
                //console.log(url);
                $.ajax({
                    type: 'POST', url: url, async: false, dataType: 'json',
                    success: function (data) {
                        if (data.status == 'success') {
                            //console.log(data);
                            $('#comments-tab').trigger('shown.bs.tab');
                        } else {
                            bootbox.alert(data.msg);
                        }
                    },
                    error: function (data) { // if error occured
                        //console.log(data);
                        bootbox.alert('Chyba při provádění operace');
                    }
                });
            }
        });
        $('a.comment_remove').removeClass('comment_remove');
    }

    function tagRemoveInit() {
        $('a.tag_remove').click(function (e) {
            e.preventDefault();
            var ajax_url = $(this).data('ajax_url');
            var element = $(this);
            if (typeof ajax_url !== "undefined") {
                //console.log(ajax_url);
                $.ajax({
                    type: 'POST', url: ajax_url, async: false, dataType: 'json',
                    success: function (data) {
                        if (data.status == 'success') {
                            //console.log(data);
                            element.parent().remove();
                            if (data.data.uuid) {
                                updateTaskOnBoard(data.data.uuid, data.data);
                            }
                        } else {
                            bootbox.alert(data.msg);
                        }
                    },
                    error: function (data) { // if error occured
                        bootbox.alert('Chyba při provádění operace');
                    }
                });
            }
        });
        $('a.tag_remove').removeClass('tag_remove');
    }

    function taskRemoveInit() {
        $('a.task_remove').click(function (e) {
            e.preventDefault();
            var ajax_url = $(this).attr('href');
            if (typeof ajax_url !== "undefined") {
                //console.log(ajax_url);
                $.ajax({
                    type: 'POST', url: ajax_url, async: false, dataType: 'json',
                    success: function (data) {
                        if (data.status == 'success') {
                            //console.log(data);
                            if (data.data.uuid) {
                                triggerOffcanvasUpdate(data.data.uuid);
                            }
                        } else {
                            bootbox.alert(data.msg);
                        }
                    },
                    error: function (data) { // if error occured
                        bootbox.alert('Chyba při provádění operace');
                    }
                });
            }
        });
        $('a.task_remove').removeClass('task_remove');
    }

    function taskTrackingInit() {
        // vždy sjednocený formát data: dd.mm.yyyy HH:mm (se zero-paddingem)
        function pad(value) {
            return value < 10 ? '0' + value : '' + value;
        }

        // parsuje "dd.mm.yyyy HH:mm" na Date; vrací null při neplatném vstupu
        function parseDateTime(value) {
            if (!value) {
                return null;
            }
            let parts = value.trim().split(' ');
            let dateParts = parts[0].split('.');
            let timeParts = (parts[1] || '00:00').split(':');
            if (dateParts.length < 3) {
                return null;
            }
            let date = new Date(
                parseInt(dateParts[2], 10),
                parseInt(dateParts[1], 10) - 1,
                parseInt(dateParts[0], 10),
                parseInt(timeParts[0], 10) || 0,
                parseInt(timeParts[1], 10) || 0
            );
            return isNaN(date.getTime()) ? null : date;
        }

        // formátuje Date zpět na "dd.mm.yyyy HH:mm"
        function formatDateTime(date) {
            return (
                pad(date.getDate()) +
                '.' +
                pad(date.getMonth() + 1) +
                '.' +
                date.getFullYear() +
                ' ' +
                pad(date.getHours()) +
                ':' +
                pad(date.getMinutes())
            );
        }

        // délka z pole "time" (HH:mm) v ms; když je 0/prázdné, výchozí 1 hodina
        function getDurationMs() {
            let time = $('#tasktracking-time').val().split(':');
            let totalMinutes =
                (parseInt(time[0], 10) || 0) * 60 + (parseInt(time[1], 10) || 0);
            if (totalMinutes <= 0) {
                totalMinutes = 60;
            }
            return totalMinutes * 60000;
        }

        function setTimeFromRange(date_from, date_to) {
            let diff = date_to.getTime() - date_from.getTime();
            let hours = Math.floor(diff / 1000 / 60 / 60);
            let minutes = Math.round(diff / 1000 / 60 - hours * 60);
            $('#tasktracking-time').val(pad(hours) + ':' + pad(minutes));
        }

        flatpickr('.flatpickr-datetime', {
            locale: 'cs',
            allowInput: true,
            enableTime: true,
            dateFormat: 'd.m.Y H:i',
            time_24hr: true
        });
        flatpickr('.flatpickr-time-24', {
            locale: 'cs',
            allowInput: true,
            enableTime: true,
            noCalendar: true,
            dateFormat: 'H:i',
            time_24hr: true
        });

        // .off pro případ opakované inicializace po AJAX vykreslení formuláře
        $('#tasktracking-date_from').off('change.tracking').on('change.tracking', function () {
            let date_from = parseDateTime($(this).val());
            let date_to = parseDateTime($('#tasktracking-date_to').val());
            if (!date_from || !date_to) {
                return;
            }

            if (date_from >= date_to) {
                // datum od nesmí být po datu do – posuneme datum do o zadanou dobu
                date_to = new Date(date_from.getTime() + getDurationMs());
                $('#tasktracking-date_to').val(formatDateTime(date_to));
            }
            setTimeFromRange(date_from, date_to);
        });
        $('#tasktracking-date_to').off('change.tracking').on('change.tracking', function () {
            let date_to = parseDateTime($(this).val());
            let date_from = parseDateTime($('#tasktracking-date_from').val());
            if (!date_from || !date_to) {
                return;
            }

            if (date_from >= date_to) {
                // datum do nesmí být před datem od – posuneme datum od o zadanou dobu
                date_from = new Date(date_to.getTime() - getDurationMs());
                $('#tasktracking-date_from').val(formatDateTime(date_from));
            }
            setTimeFromRange(date_from, date_to);
        });
        $('#tasktracking-time').off('change.tracking').on('change.tracking', function () {
            let data = $(this).val().split(':');
            let hours = parseInt(data[0], 10) || 0;
            let minutes = parseInt(data[1], 10) || 0;

            let date_from = parseDateTime($('#tasktracking-date_from').val());
            if (!date_from) {
                return;
            }

            // datum do dopočítáme přes časový posun (řeší i přechod přes půlnoc/měsíc)
            let date_to = new Date(
                date_from.getTime() + (hours * 60 + minutes) * 60000
            );
            $('#tasktracking-date_from').val(formatDateTime(date_from));
            $('#tasktracking-date_to').val(formatDateTime(date_to));
        });
    }

    function taskEditInit() {
        $('a.edit_task').click(function (e) {
            e.preventDefault();
            var url = $(this).attr('href');
            if (typeof url !== "undefined") {
                //console.log(url);
                $.ajax({
                    type: 'POST', url: url, async: false, dataType: 'json',
                    success: function (data) {
                        if (data.status == 'success') {
                            //console.log(data);
                            $('#editTaskModal').html(data.data.content).on('shown.bs.modal', function () {
                                var select = $('#editTaskModal select[autofocus]:first');
                                var input = $('#editTaskModal input[autofocus]:first');
                                if (select.length > 0) {
                                    select.focus();
                                }
                                if (input.length > 0) {
                                    input.focus();
                                }
                                var choice = $('#editTaskModal select.tag_choice');
                                if (choice.length > 0) {
                                    let choices = new Choices(choice[0], {
                                        removeItemButton: true,
                                        placeholder: true,
                                        loadingText: 'Načítání...',
                                        noResultsText: 'Nebyly nalezeny žádné výsledky',
                                        noChoicesText: 'Žádné možnosti na výběr',
                                        itemSelectText: 'Klikněte pro výběr',
                                        uniqueItemText: 'Lze přidat pouze jedinečné hodnoty',
                                    });
                                    $('#editTaskModal #tag-switch').change(function () {
                                        if ($(this).prop('checked')) {
                                            $('#editTaskModal #tag-select').addClass('d-none');
                                            $('#editTaskModal #tag-new').removeClass('d-none');
                                        } else {
                                            $('#editTaskModal #tag-new').addClass('d-none');
                                            $('#editTaskModal #tag-select').removeClass('d-none');
                                        }
                                    });
                                }
                                if ($('textarea.tinymce').length > 0) {
                                    if (url.includes('subtask-add')) {
                                        tinymceInit(350);
                                    } else {
                                        tinymceInit();
                                    }
                                }
                                taskTrackingInit();
                            }).on('hidden.bs.modal', function () {
                                $('#editTaskModal').html('');
                            });
                            $('#task-api-form').on('submit', function (e) {
                                e.preventDefault();
                                if (typeof tinymce !== 'undefined') {
                                    tinymce.triggerSave();
                                    if (tinymce.activeEditor !== null) {
                                        tinymce.activeEditor.save();
                                    }
                                }
                                var form = $(this);
                                var actionUrl = form.attr('action');
                                var form_data = new FormData(form[0]);
                                $.ajax({
                                    type: "POST",
                                    url: actionUrl,
                                    data: form_data,
                                    enctype: "multipart/form-data",
                                    processData: false,
                                    contentType: false,
                                    success: function (data) {
                                        if (data.data.reload) {
                                            window.location.reload();
                                        }
                                        if (data.data.uuid) {
                                            triggerOffcanvasUpdate(data.data.uuid);
                                            updateTaskOnBoard(data.data.uuid, data.data);
                                        }
                                        if (data.data.comment) {
                                            $('#comments-tab').trigger('shown.bs.tab');
                                        }
                                        if (data.data.tracked) {
                                            $('#worklog-tab').trigger('shown.bs.tab');
                                            $('#allTracked').html(data.data.tracked);
                                            setProgressbarNewWidth($('#allTrackedProgress'), data.data.progress);
                                        }
                                    },
                                    error: function (data) { // if error occured
                                        bootbox.alert(data.responseJSON.msg + ': ' + data.responseJSON.data[0]);
                                    },
                                    complete: function () {
                                        $('#editTaskModal').html('');
                                    }
                                });
                                $('#editTaskModal').modal('hide');
                            });
                            $('#editTaskModal').modal('show');
                        } else {
                            bootbox.alert(data.msg);
                        }
                    },
                    error: function (data) { // if error occured
                        bootbox.alert('Chyba při provádění operace');
                    }
                });
            }
        });
        $('a.edit_task').removeClass('edit_task');
        subtaskEditInit();
        taskRemoveInit();
    }

    function subtaskEditInit() {
        $('a.edit_subtask').click(function (e) {
            e.preventDefault();
            var url = $(this).attr('href');
            if (typeof url !== "undefined") {
                //console.log(url);
                $.ajax({
                    type: 'POST', url: url, async: false, dataType: 'json',
                    success: function (data) {
                        if (data.status == 'success') {
                            //console.log(data);
                            $('#editTaskModal').html(data.data.content).on('shown.bs.modal', function () {
                                var select = $('#editTaskModal select[autofocus]:first');
                                var input = $('#editTaskModal input[autofocus]:first');
                                if (select.length > 0) {
                                    select.focus();
                                }
                                if (input.length > 0) {
                                    input.focus();
                                }
                                if ($('textarea.tinymce').length > 0) {
                                    tinymceInit();
                                }
                            }).on('hidden.bs.modal', function () {
                                $('#editTaskModal').html('');
                            });
                            $('#task-api-form').on('submit', function (e) {
                                e.preventDefault();
                                if (typeof tinymce !== 'undefined') {
                                    tinymce.triggerSave();
                                    if (tinymce.activeEditor !== null) {
                                        tinymce.activeEditor.save();
                                    }
                                }
                                var form = $(this);
                                var actionUrl = form.attr('action');
                                var form_data = new FormData(form[0]);
                                $.ajax({
                                    type: "POST",
                                    url: actionUrl,
                                    data: form_data,
                                    enctype: "multipart/form-data",
                                    processData: false,
                                    contentType: false,
                                    success: function (data) {
                                        if (data.data.reload) {
                                            window.location.reload();
                                        }
                                        if (data.data.parent_uuid) {
                                            triggerOffcanvasUpdate(data.data.parent_uuid);
                                            updateTaskOnBoard(data.data.uuid, data.data);
                                        }
                                    },
                                    error: function (data) { // if error occured
                                        bootbox.alert(data.responseJSON.msg + ': ' + data.responseJSON.data[0]);
                                    },
                                    complete: function () {
                                        $('#editTaskModal').html('');
                                    }
                                });
                                $('#editTaskModal').modal('hide');
                            });
                            $('#editTaskModal').modal('show');
                        } else {
                            bootbox.alert(data.msg);
                        }
                    },
                    error: function (data) { // if error occured
                        bootbox.alert('Chyba při provádění operace');
                    }
                });
            }
        });
        $('a.edit_subtask').removeClass('edit_subtask');
    }

    function setProgressbarNewWidth(element, progress) {
        let oldWidth = element.css('width').replace('px', '');
        let oldValue = element.attr('aria-valuenow');
        element.css('width', ((oldWidth / oldValue) * progress) + 'px').attr('aria-valuenow', progress);
    }

    function tinymceInit(inputHeight = 650) {
        let current_uuid = $('#current-project-name').data('uuid');
        var maxImageWidth = inputHeight + 50;
        $.get('/index.php/kanban/api/tinymce?project_uuid=' + current_uuid, function (data) {
            tinymce.remove();
            tinymce.init({
                selector: 'textarea.tinymce',
                language: 'cs',
                license_key: 'gpl',
                promotion: false,
                branding: false,
                resize: true,
                min_height: inputHeight,
                height: inputHeight,
                plugins: [
                    'advlist',
                    'anchor',
                    'autolink',
                    'charmap',
                    'code',
                    'codesample',
                    'fullscreen',
                    'image',
                    'insertdatetime',
                    'link',
                    'lists',
                    'preview',
                    'searchreplace',
                    'table',
                    'visualblocks',
                    'wordcount',
                    'variable',
                    'emoticons'
                ],
                setup: function (editor) {
                    editor.on('init', function (args) {
                        let editor = args.target;
                        editor.on('PreProcess', function (e) {
                            $(e.node).find('img').each(function () {
                                tinymce.DOM.setAttribs(this, { class: 'img-fluid' });
                            });
                        });
                        editor.on('focus', () => {
                            const wraper = document.querySelector('.tox-sidebar-wrap');
                            wraper.classList.add('editor-focused');
                        });
                        editor.on('blur', () => {
                            const wraper = document.querySelector('.tox-sidebar-wrap');
                            wraper.classList.remove('editor-focused');
                            window.tinymce.triggerSave();
                            if (window.tinymce.activeEditor !== null) {
                                window.tinymce.activeEditor.save();
                            }
                        });
                    });
                },
                variable_mapper: data.data.variable_mapper,
                variable_valid: data.data.variable_valid,
                content_style:
                    '.variable{cursor:default;background-color:#e5edff;color:#003cc7;padding:4px 10px;border-radius:3px;font-weight:700;font-style:normal;font-size:14px;display:inline-block;line-height:16px}' +
                    ' img{max-width:100%;height:auto}',
                menubar: '',
                toolbar:
                    'undo redo | styles | ' +
                    'bold italic underline strikethrough forecolor backcolor | ' +
                    'alignleft aligncenter alignright alignjustify | bullist numlist outdent indent | ' +
                    'link image removeformat blockquote codesample code emoticons'
            });
        });
    }

    function tooltipInit() {
        const tooltipTriggerList = document.querySelectorAll('[data-bs-toggle="tooltip"]')
        const tooltipList = [...tooltipTriggerList].map(tooltipTriggerEl => new bootstrap.Tooltip(tooltipTriggerEl))
    }

    $(function () {

        $(document).on('show.bs.modal', '.modal', function () {
            $(this).appendTo('body');
        });

        $(document).on('change', '#create_new_phase', function () {
            if ($(this).is(':checked')) {
                $('.current_phase').hide();
                $('.new_phase').show();
                $('#projectphase-phase_id').prop('disabled', true);
                $('#boardphase-phase_id').prop('disabled', true);
                $('#phase-name').prop('disabled', false);
                $('#phase-color').prop('disabled', false);
                $('#creation_type').val('new');
            } else {
                $('.current_phase').show();
                $('.new_phase').hide();
                $('#projectphase-phase_id').prop('disabled', false);
                $('#boardphase-phase_id').prop('disabled', false);
                $('#phase-name').prop('disabled', true);
                $('#phase-color').prop('disabled', true);
                $('#creation_type').val('current');
            }
        });

        $(document).on('click', '.add-task-button', function () {
            $('#task-phase_id').val($(this).data('phase_id'));
        });

        $(document).on('click', '.open_task_detail', function (event, activeTab) {
            var task_uuid = $(this).data('uuid');
            openTaskDetail(task_uuid, activeTab);
        });

    $('#kanbanAddTask').on('shown.bs.modal', function () {
        var choice = $('#kanbanAddTask select.tag_choice');
        if (choice.length > 0) {
            let choices = new Choices(choice[0], {
                removeItemButton: true,
                placeholder: true,
                loadingText: 'Načítání...',
                noResultsText: 'Nebyly nalezeny žádné výsledky',
                noChoicesText: 'Žádné možnosti na výběr',
                itemSelectText: 'Klikněte pro výběr',
                uniqueItemText: 'Lze přidat pouze jedinečné hodnoty',
            });
        }
        if ($('textarea.tinymce').length > 0) {
            tinymceInit(350);
        }
    });

    $(document).keydown(function (e) {
        // ESCAPE key pressed
        if (e.keyCode == 27) {
            var element = document.getElementById('offcanvasKanban');
            if (element !== null && element.classList.contains('show')) {
                element.classList.remove('show');
                document.body.style.removeProperty('overflow');
            }
        }
    });

    tabChangeInit();
    tagRemoveInit();
    taskEditInit();
    taskCompletedInit();
    taskSupportInit();
});

const copyToClipboard = async (text, element) => {
    const tooltip = bootstrap.Tooltip.getOrCreateInstance(element);
    var originalTitle = tooltip._getTitle();
    try {
        await navigator.clipboard.writeText(text);
        //console.log("Copied to clipboard!");
        tooltip.setContent({ '.tooltip-inner': 'Odkaz zkopírován' });
    } catch (error) {
        console.error("Failed to copy to clipboard:", error);
        tooltip.setContent({ '.tooltip-inner': 'Odkaz se nepodařilo zkopírovat' });
    }
    tooltip.update();
    setTimeout(() => {
        tooltip.hide();
        tooltip.setContent({ '.tooltip-inner': originalTitle });
        tooltip.update();
    }, 5000);
};

window.copyToClipboard = copyToClipboard;
window.refreshFilesTab = refreshFilesTab;
